import { render, staticRenderFns } from "./customizationLanding.vue?vue&type=template&id=1f283979"
import script from "./customizationLanding.vue?vue&type=script&lang=js"
export * from "./customizationLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports